<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div
    class="bg-ontick-green-700 dark:bg-ontick-steel-600 py-12 text-gray-50 dark:bg-opacity-40 dark:text-gray-300 sm:py-16 lg:py-20"
  >
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-4xl text-center">
        <h2 class="text-2xl font-extrabold sm:text-4xl">
          {{ data.title }}
        </h2>
        <p class="text-md mt-3 dark:text-gray-400 sm:mt-4 sm:text-xl">
          {{ data.subtitle }}
        </p>
      </div>
    </div>
    <div class="mt-10">
      <div class="relative">
        <div class="absolute inset-0 h-1/2" />
        <div class="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div class="mx-auto max-w-4xl">
            <dl
              class="grid grid-cols-1 rounded-lg"
              :class="[
                { 'gap-4': data.data.length > 6 },
                `sm:grid-cols-${data.data.length}`,
              ]"
            >
              <template v-if="data.data.length > 6">
                <dl
                  class="dark:bg-ontick-graphite-500 flex flex-col rounded-lg bg-white p-6"
                  v-for="(stat, index) in data.data"
                  :key="index"
                >
                  <dd
                    class="order-2 mt-1 font-semibold tracking-tight text-gray-900 dark:text-gray-300"
                    :class="data.smalltext ? 'text-lg' : 'text-3xl'"
                  >
                    {{ stat.value }}
                  </dd>
                  <dt
                    class="order-1 truncate text-sm font-medium text-gray-500 dark:text-gray-400"
                  >
                    {{ stat.description }}
                  </dt>
                </dl>
              </template>

              <template v-else>
                <dl
                  class="flex flex-col p-6 text-center"
                  v-for="(stat, index) in data.data"
                  :key="index"
                >
                  <dd
                    class="order-1 font-extrabold"
                    :class="data.smalltext ? 'text-lg' : 'text-4xl sm:text-5xl'"
                  >
                    {{ stat.value }}
                  </dd>
                  <dt
                    class="order-2 mt-2 text-lg font-medium leading-6 dark:text-gray-400"
                  >
                    {{ stat.description }}
                  </dt>
                </dl>
              </template>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
    },
  },
};
</script>
